module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "oxigrafia inner-screen"
  }, [_c('video-page', {
    attrs: {
      "data": _vm.data
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fbe5d36"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Oxigrafia.vue
// module id = 567
// module chunks = 1